import { Loader } from '@libs/ui/ds'
import { routes } from '@spa/core/router/appRoutesConfig'
import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'

import { useAccountCreation } from '../../hooks/useAccountCreation'
import { isAccountUserInfoValid } from '../AccountUserInfoStep/AccountUserInfoForm/AccountUserInfoForm.validations'

import { AccountCompanyInfoForm } from './AccountCompanyInfoForm/AccountCompanyInfoForm'

export const AccountCompanyInfoStep: React.FC = () => {
  const [isInitialLoad, setIsInitialLoad] = useState(true)
  const { profile, isFetchingDraftAccountData } = useAccountCreation()

  useEffect(() => {
    if (!isFetchingDraftAccountData) {
      setIsInitialLoad(false)
    }
  }, [isFetchingDraftAccountData])

  if (isInitialLoad) {
    return <Loader.Overlay />
  }

  if (!isAccountUserInfoValid(profile)) {
    return <Navigate to={routes.accountCreationUserInfo.path} replace />
  }

  return <AccountCompanyInfoForm />
}
